import { Link } from "react-router-dom";
import { channels } from "@/mocks/streams";
import StreamCard from "@/components/feature/StreamCard";
import HeroCarousel from "@/pages/home/components/HeroCarousel";
import CategoryGrid from "@/pages/home/components/CategoryGrid";
import HotHostList from "@/pages/home/components/HotHostList";
import ChatPreview from "@/pages/home/components/ChatPreview";
import NewHosts from "@/pages/home/components/NewHosts";
import PlatformIntro from "@/pages/home/components/PlatformIntro";

export default function Home() {
  const liveChannels = channels.filter((channel) => channel.isLive).sort((a, b) => b.viewers - a.viewers);
  const featured = liveChannels.slice(0, 5);
  const hotLives = liveChannels.slice(0, 9);
  const hotHosts = [...channels].sort((a, b) => b.viewers - a.viewers).slice(0, 6);

  return (
    <div className="w-full px-4 py-6 md:px-6 md:py-8">
      <div className="animate-fade-up">
        <HeroCarousel items={featured} />
      </div>

      <section className="mt-8">
        <SectionHeader title="直播分类" subtitle="按兴趣快速找到想看的直播" icon="ri-apps-2-line" />
        <div className="mt-4">
          <CategoryGrid />
        </div>
      </section>

      <section className="mt-10 grid grid-cols-1 gap-6 lg:grid-cols-3">
        <div className="lg:col-span-2">
          <SectionHeader
            title="热门直播"
            subtitle="此刻最受观众欢迎的直播内容"
            icon="ri-fire-line"
            action={{ label: "查看全部", to: "/search" }}
          />
          <div className="mt-4 grid grid-cols-1 gap-4 sm:grid-cols-2">
            {hotLives.map((channel) => (
              <StreamCard key={channel.id} channel={channel} />
            ))}
          </div>
        </div>

        <aside className="space-y-4">
          <HotHostList items={hotHosts} />
          <ChatPreview />
        </aside>
      </section>

      <section className="mt-10">
        <NewHosts />
      </section>

      <section className="mt-10">
        <PlatformIntro />
      </section>
    </div>
  );
}

interface SectionHeaderProps {
  title: string;
  subtitle: string;
  icon: string;
  action?: { label: string; to: string };
}

function SectionHeader({ title, subtitle, icon, action }: SectionHeaderProps) {
  return (
    <div className="flex flex-col gap-2 sm:flex-row sm:items-end sm:justify-between">
      <div>
        <h2 className="flex items-center gap-2 font-heading text-lg font-semibold text-foreground-950 md:text-xl">
          <span className="w-6 h-6 flex items-center justify-center text-primary-500">
            <i className={`${icon} text-xl`}></i>
          </span>
          {title}
        </h2>
        <p className="mt-1 text-sm text-foreground-400">{subtitle}</p>
      </div>
      {action && (
        <Link
          to={action.to}
          className="flex items-center gap-1 text-sm text-primary-500 transition-colors hover:text-primary-400 whitespace-nowrap"
        >
          {action.label}
          <span className="w-4 h-4 flex items-center justify-center">
            <i className="ri-arrow-right-s-line"></i>
          </span>
        </Link>
      )}
    </div>
  );
}